export const ILocation = {
  countriesCount: 0,
  isEnabled: true,
};
